export const fontWeightValues = {
  font_weight_200: "200",
  font_weight_400: "400",
  font_weight_500: "500",
  font_weight_600: "600",
  font_weight_700: "700",
};
